define('frontend-common-components/gettingStartedPanel/js/constants/events',[],function () {
    'use strict';

    return {
        close: 'gettingStartedClose'
    };
});
